// extracted by mini-css-extract-plugin
export default {"form":"SettingsForm_form__3g2xj","field":"SettingsForm_field__LpbmW"};